import { Button, Typography } from '@material-tailwind/react'
import React from 'react'
import { Link } from 'react-router-dom'

function CallToAction() {
  return (
    <div className='mb-16 px-7 md:px-11 text-center bg-gray-300 py-8'>
      <Typography variant='h4' className='pb-5 underline underline-offset-8'>Dapatkan Pekerjaan dengan Potensi Terbaik</Typography>
      <Typography variant='small' className='pb-5'>
        Lorem ipsum dolor, sit amet consectetur adipisicing elit.
        Culpa, nisi quis non laboriosam, a voluptas animi, 
        consequuntur quam provident voluptates illum? Velit, 
        et blanditiis labore provident esse sunt, 
        nam quos eos facere repellendus sit natus voluptate eius placeat minima nulla deleniti? 
        Consequuntur perferendis eos iure ullam, itaque fugit natus neque.
      </Typography>
      <Button>
        <Link to='/register'>Registasi Sekarang!</Link>
      </Button>
    </div>
  )
}

export default CallToAction